const CardSettingTypes = {
    DIGITAL: "DIGITAL",
    INSTANT: "INSTANT",
    EMBOSSED:"EMBOSSED",
};

export default CardSettingTypes;
